export const STORAGE_NAMES = {
  ACCESS_TOKEN: "@CBK/KONSULTANT/CRM/ACCESS_TOKEN",
  REFRESH_TOKEN: "@CBK/KONSULTANT/CRM/REFRESH_TOKEN",
};
